import {Link, useLocation} from 'react-router-dom';
import {usePageInfo} from '@/services/store';
import {Breadcrumb} from '@/ui-kit';
import {ChevronRight} from '@/ui-kit/icons';
import {getActiveModuleName} from '@/utils/get-active-module-name';
import styles from './breadcrumbs.module.scss';

const DEFAULT_LINK = '#';

export const Breadcrumbs = () => {
  const {pathname} = useLocation();
  const {pageInfo} = usePageInfo();
  const activeModuleName = getActiveModuleName(pathname);

  if (!activeModuleName) {
    return null;
  }

  const getItems = () => {
    const changeDataForCurrentPage = (data) => {
      data[data.length - 1] = {
        ...data[data.length - 1],
        as: undefined,
        isCurrentPage: true,
      };

      return data;
    };
    let items = [
      {
        children: activeModuleName.replace(/-/g, ' '),
        as: Link,
        to: `/${activeModuleName ? activeModuleName : DEFAULT_LINK}`,
      },
    ];

    if (pageInfo) {
      const pageData = Array.isArray(pageInfo) ? pageInfo : [pageInfo];
      items = [
        ...items,
        ...pageData.map(({title, link}) => ({
          children: title,
          as: Link,
          to: link,
        })),
      ];
    }

    return changeDataForCurrentPage(items);
  };

  return (
    <Breadcrumb
      data-testid="breadcrumbs"
      className={styles.breadCrumbs}
      separator={<ChevronRight />}
      items={getItems()}
    />
  );
};
